// extracted by mini-css-extract-plugin
module.exports = {"disabled":"Images_disabled__QXSlO"};